import Link from 'next/link';
import styled, { useTheme } from 'styled-components';
import { css } from '@styled-system/css';
import { useRouter } from 'next/router';

import {
  lcTopFilterComponentProp,
  lcTopFilterProps,
} from 'humanity/components/lcTopFilter/lcTopFilter.types.js';
import Button from 'humanity/primitives/button';
import Flex from 'humanity/primitives/flex';
import { getLcIcon } from 'utils/getLcIcon';

const StyledIcon = styled.span(css({ marginRight: 2 }));

const Filter = ({ filter }) => {
  const router = useRouter();
  const { name, displayName } = filter;
  const theme = useTheme();

  const Icon = getLcIcon(name);
  const newQuery = { slug: name };

  return (
    <Button
      as={Link}
      variant="select"
      btnSize="sm"
      href={{ pathname: router.pathname, query: newQuery }}
      active={router.query.slug === name ? 'active' : undefined}
    >
      <Flex alignItems="center" height="18px">
        {Icon && (
          <StyledIcon>
            <Icon size={16} color={theme.colors.blue100} />
          </StyledIcon>
        )}
        {displayName}
      </Flex>
    </Button>
  );
};

const StyledFlex = styled(Flex)(
  css({
    py: 5,
    pb: [3, 5],
    position: ['static', 'sticky'],
    top: 7,
    background: 'white',
    zIndex: 1,
    whiteSpace: ['nowrap', 'wrap'],
    overflowX: ['scroll', 'visible'],
    marginRight: [-4, 0],
    marginLeft: ['-4px', 0],
    paddingLeft: ['4px', 0],
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  })
);

Filter.propTypes = { ...lcTopFilterComponentProp };

const LcTopFilter = ({ filters }) => (
  <StyledFlex>
    {filters?.map((filter) => (
      <Filter key={filter.name} filter={filter} />
    ))}
  </StyledFlex>
);

LcTopFilter.propTypes = {
  ...lcTopFilterProps,
};

export default LcTopFilter;
